import React from 'react'
import PropTypes from 'prop-types'

const HeaderTab = props => {
  const formattedAssignedQuestsCount = props.count > 999 ? '999+' : props.count

  return (
    <li>
      <a className={props.klass} onClick={props.clickHandler}>
        <div className="header-tab-label">{props.intlLabel}</div>
        {props.count >= 0 && (
          <div className="count">{formattedAssignedQuestsCount}</div>
        )}
      </a>
    </li>
  )
}

HeaderTab.propTypes = {
  intlLabel: PropTypes.element.isRequired,
  klass: PropTypes.string.isRequired,
  clickHandler: PropTypes.func.isRequired,
  count: PropTypes.number
}

export default HeaderTab



// WEBPACK FOOTER //
// ./src/components/myquests/HeaderTab.js